module.exports = __webpack_public_path__ + "img/google-bitcoin-price-chart.da02db86.png";